// @ts-nocheck
import { Column } from 'react-table'
import { useState } from 'react'
import { JobCustomHeader } from './JobCustomHeader'
import { JobActionsCell } from './JobActionsCell'
import { useQueryResponsePagination, useQueryResponse } from '../../core/QueryResponseProvider'
import { Job } from '../../core/_models'
import dayjs from 'dayjs'
import { toast } from 'react-toastify'
import { updateJobStatus } from '../../../_requests'

const JOBTYPE_CONFIG: Record<string, { label: string; className: string }> = {
  FULL_TIME: { label: 'Full Time', className: 'badge badge-light-primary' },
  PART_TIME: { label: 'Part Time', className: 'badge badge-light-info' },
  CASUAL: { label: 'Casual', className: 'badge badge-light-green' },
}

const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  ACTIVE: { label: 'Publish', className: 'badge badge-light-green' },
  DRAFT: { label: 'Draft', className: 'badge badge-light-info' },
  CLOSED: { label: 'Closed', className: 'badge badge-light-danger' },
}

const APPROVAL_STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  PENDING: { label: 'Pending', className: 'text-muted' },
  APPROVED: { label: 'Approve', className: 'text-theme-green' },
  REJECTED: { label: 'Reject', className: 'text-danger' },
}

const jobsColumns = (onOpenApplicantsModal?: (jobId: string, jobTitle: string) => void): ReadonlyArray<Column<Job>> => [
  {
    Header: (props) => <JobCustomHeader tableProps={props} title='Sr No.' />,
    id: 'sr_no',
    Cell: ({ row }) => {
      const pagination = useQueryResponsePagination()
      const page = pagination?.page || 1
      const per = pagination?.items_per_page || 15
      const sr = (page - 1) * per + row.index + 1
      return <div>{sr}</div>
    },
  },
{
    Header: (props) => <JobCustomHeader tableProps={props} title='Job Title' />,
    accessor: 'title',
    Cell: ({ value, row }) => (
      // <Link
      //   to={`/job-details/${row.original.id}`}
      //   className='text-dark text-hover-primary fw-bold'
      // >
      //   {value}
      // </Link>
      <span className='text-dark fw-bold'>
        {value}
      </span>
    ),
  },
  
  {
    Header: (props) => <JobCustomHeader tableProps={props} title='Job Type' />,
    id: 'type',
    accessor: 'jobType',
    Cell: ({ value }) => {
      const role = JOBTYPE_CONFIG[value]

      return (
        <span className={`font-12 fw-bold badge ${role?.className ?? 'bg-secondary'}`}>
          {role?.label ?? value}
        </span>
      )
    },
  },
  {
    Header: (props) => <JobCustomHeader tableProps={props} title='Location' />,
    id: 'location',
    accessor: 'locations',
    Cell: ({ row }) => {
      const locations = row.original.locations
      let displayText = '-'

      if (Array.isArray(locations) && locations.length > 0) {
        displayText = locations.join('; ')
      }

      return (
        <div
          className="text-truncate"
          style={{ maxWidth: "350px" }}
          title={displayText}
        >
          {displayText}
        </div>
      )
    },
  },
  {
    Header: (props) => <JobCustomHeader tableProps={props} title={<span>Salary $</span>} />,
    id: 'salary',
    accessor: 'compensation_min',
    Cell: ({ row }) => {
      const min = row.original.compensation_min
      const max = row.original.compensation_max
      if (min && max) {
        return `${min} to ${max}`
      }
      if (min) {
        return `${min}`
      }
      if (max) {
        return `${max}`
      }
      return '-'
    }
  },
  {
    Header: (props) => (
      <JobCustomHeader tableProps={props} title='Total Applicants' />
    ),
    accessor: 'applicants_count',
    Cell: ({ value, row }) => (
      <span
        className='text-primary fw-bold cursor-pointer'
        style={{ cursor: 'pointer', textDecoration: 'underline', textUnderlineOffset: '1px', textDecorationThickness: '2px' }}
        onClick={() => {
          if (onOpenApplicantsModal) {
            onOpenApplicantsModal(row.original.id, row.original.jobTitle)
          }
        }}
      >
        {value || 0}
      </span>
    ),
  },
  {
    Header: (props) => (
      <JobCustomHeader tableProps={props} title='Created Date' />
    ),
    id: 'date',
    accessor: 'createdDate',
    Cell: ({ value }) =>
      value ? dayjs(value).format('DD MMM YYYY, hh:mm A') : '-',
  },
  {
    Header: (props) => <JobCustomHeader tableProps={props} title='Status' />,
    accessor: 'status',
    Cell: ({ value }) => {
      const role = STATUS_CONFIG[value]

      return (
        <span className={`font-12 fw-bold badge ${role?.className ?? 'bg-secondary'}`}>
          {role?.label ?? value}
        </span>
      )
    },
  },
  {
    Header: (props) => <JobCustomHeader tableProps={props} title='Is Approval' />,
    accessor: 'approval_status',
    Cell: ({ value }) => {
      const approval = APPROVAL_STATUS_CONFIG[value]

      return (
        <span className={`font-13 fw-bold text ${approval?.className ?? 'text-secondary'}`}>
          {approval?.label ?? value}
        </span>
      )
    },
  },
  {
    Header: (props) => (
      <JobCustomHeader tableProps={props} title='Is Active' />
    ),
    accessor: 'is_active',
    Cell: ({ value, ...props }) => {
      const { refetch } = useQueryResponse()
      const [processing, setProcessing] = useState(false)

      const handleToggle = async (e: any) => {
        const checked = e.target.checked ? 'activate' : 'deactivate'
        setProcessing(true)
        try {
          // the API expects 1/0; allow string or number values coming from backend
          const data = {
            action: checked,
          }
          await updateJobStatus(props.data[props.row.index].id, data)
          toast.success(`Job ${checked ? 'activated' : 'deactivated'} successfully`)
          // refresh list after status change
          refetch()
        } catch (err: any) {
          console.error(err)
          // revert checkbox if the update failed
          e.target.checked = !checked
          toast.error('Failed to update status')
        } finally {
          setProcessing(false)
        }
      }

      return (
        <div className='form-check form-switch'>
          <input
            className='form-check-input cursor-pointer'
            type='checkbox'
            disabled={processing}
            checked={value === 1 || value === true}
            onChange={handleToggle}
          />
        </div>
      )
    },
  },
  {
    Header: (props) => (
      <JobCustomHeader tableProps={props} title='Actions' />
    ),
    id: 'actions',
    Cell: ({ ...props }) => (
      <JobActionsCell
        id={props.data[props.row.index].id}
        status={props.data[props.row.index].status}
        approval_status={props.data[props.row.index].approval_status}
      />
    ),
  },
]

export { jobsColumns }
